(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["learn-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lm-drawer')) {
    customElements.define(
      'lm-drawer',
      class LmDrawer extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return
          this._initialized = true

          this.trigger = this.querySelector('.lmd__trigger')
          this.modal = this.querySelector('.lmd__modal')
          if (!this.trigger || !this.modal) return

          this.onKeydown = (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('is-open')) this.close()
          }

          this.trigger.addEventListener('click', (e) => {
            e.preventDefault()
            this.open()
          })

          this.modal.querySelectorAll('[data-lmd-close]').forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault()
              this.close()
            })
          })
        }

        open() {
          if (!this.modal) return

          this.modal.hidden = false
          // Force a paint so the .is-open transition runs.
          this.modal.offsetHeight
          this.modal.classList.add('is-open')
          document.body.classList.add('lmd-open')
          document.addEventListener('keydown', this.onKeydown)

          const closeBtn = this.modal.querySelector('.lmd__close')
          if (closeBtn) {
            try {
              closeBtn.focus({ preventScroll: true })
            } catch (e) {
              closeBtn.focus()
            }
          }
        }

        close() {
          this.modal.classList.remove('is-open')
          document.removeEventListener('keydown', this.onKeydown)
          if (!document.querySelector('.lmd__modal.is-open')) {
            document.body.classList.remove('lmd-open')
          }
          setTimeout(() => {
            if (!this.modal.classList.contains('is-open')) this.modal.hidden = true
          }, 520)

          try {
            this.trigger.focus({ preventScroll: true })
          } catch (e) {
            this.trigger.focus()
          }
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
